import Flag from './flag';

export default Flag;
